import articleTypes from "@/view/constants/articleTypes";

const { ARTICLE_NEWS, ARTICLE_FICTION, ARTICLE_POEM } = articleTypes;

const articleTypeToLabelMap = {
  ARTICLE_BIOGRAPHY: "biography",
  ARTICLE_DRAMA: "drama",
  ARTICLE_EDITORIAL: "editorial",
  ARTICLE_FICTION: "fiction",
  ARTICLE_INFOGRAPHIC: "infographic",
  ARTICLE_INFORMATION: "information",
  ARTICLE_MAP: "map",
  ARTICLE_PHOTO: "photo",
  ARTICLE_POEM: "poem",
};

const getArticleCategory = (contentData, contentMetadata) => {
  const articleType = contentData?.data.article_type;

  if (!articleType) return null;

  const isFiction = articleType === ARTICLE_FICTION;
  const isPoem = articleType === ARTICLE_POEM;

  // 'library' was previously used to identify non-news content.
  const categoryGroup = articleType === ARTICLE_NEWS ? "news" : "library";
  const category = contentMetadata.find(
    (metadata) =>
      metadata.content_type === "CATEGORY" &&
      metadata.data.group === categoryGroup,
  );
  const shouldShowArticleType =
    isFiction || isPoem || !category?.data.display_name;

  if (shouldShowArticleType) {
    return articleTypeToLabelMap[articleType];
  }
  return category?.data.display_name;
};

export default getArticleCategory;
